export default __webpack_public_path__ + "static/media/logo4.3fca8bd7.png";